export enum CodeSubject {
  PROC_PA = 'PROC_PA',
  PROC_MA = 'PROC_MA',
  SANIT = 'SANIT',
  INT_NAS = 'INT_NAS',
  INT_NAS2 = 'INT_NAS2',
  INT_NAS2_C1 = 'INT_NAS2_C1',
  INT_NAS_1 = 'INT_NAS_1',
  INT_NAS_2 = 'INT_NAS_2',
  INT_NAS_3 = 'INT_NAS_3',
  INT_NAS_4 = 'INT_NAS_4',
  INT_NAS_5 = 'INT_NAS_5',
  INT_NAS_6 = 'INT_NAS_6',
  INT_NAS_7 = 'INT_NAS_7',
  INT_NAS_8 = 'INT_NAS_8',
  INT_NAS_9 = 'INT_NAS_9',
  INT_NAS_10 = 'INT_NAS_10',
  INT_NAS_11 = 'INT_NAS_11',
  INT_NAS_12 = 'INT_NAS_12',
  INT_NAS_13 = 'INT_NAS_13',
  INT_NAS_14 = 'INT_NAS_14',
  INT_NAS_15 = 'INT_NAS_15',
  INT_NAS_16 = 'INT_NAS_16',
  INT_NAS_17 = 'INT_NAS_17',
  INT_NAS_18 = 'INT_NAS_18',
  INT_NAS_19 = 'INT_NAS_19',
  INT_NAS_20 = 'INT_NAS_20',
  FIGLIO_1 = 'FIGLIO_1',
  FIGLIO_2 = 'FIGLIO_2',
  FIGLIO_3 = 'FIGLIO_3',
  FIGLIO_4 = 'FIGLIO_4',
  FIGLIO_5 = 'FIGLIO_5',
  FIGLIO_6 = 'FIGLIO_6',
  FIGLIO_7 = 'FIGLIO_7',
  FIGLIO_8 = 'FIGLIO_8',
  FIGLIO_9 = 'FIGLIO_9',
  FIGLIO_10 = 'FIGLIO_10',
  FIGLIO_11 = 'FIGLIO_11',
  FIGLIO_12 = 'FIGLIO_12',
  FIGLIO_13 = 'FIGLIO_13',
  FIGLIO_14 = 'FIGLIO_14',
  FIGLIO_15 = 'FIGLIO_15',
  FIGLIO_16 = 'FIGLIO_16',
  FIGLIO_17 = 'FIGLIO_17',
  FIGLIO_18 = 'FIGLIO_18',
  FIGLIO_19 = 'FIGLIO_19',
  FIGLIO_20 = 'FIGLIO_20',
  MADRE = 'MADRE',
  PADRE = 'PADRE',
  MADREBIO = 'MADREBIO',
  PADREBIO = 'PADREBIO',
  INTERPR = 'INTERPR',
  COMPARENTE1 = 'COMPARENTE1',
  COMPARENTE2 = 'COMPARENTE2',
  DECEDUTO = 'DECEDUTO',
  CONIUGE = 'CONIUGE',
  UNITOCIVILMENTE = 'UNITOCIVILMENTE',
  INTEST = 'INTEST',
  INTEST1 = 'INTEST1',
  INTEST2 = 'INTEST2',
  INT_ANN = 'INT_ANN',
  ASCEN = 'ASCEN',
  RICHIEDENTE = 'RICHIEDENTE',
  RICHIEDENTE_PRIVATO = 'RICHIEDENTE_PRIVATO',
  DICHIARANTE_PROC_PA = 'DICHIARANTE_PROC_PA',
  DICHIARANTE_PROC_MA = 'DICHIARANTE_PROC_MA',
  DICHIARANTE_SANIT = 'DICHIARANTE_SANIT',
  OFFICIANTE_UNI_CIV = 'OFFICIANTE_UNI_CIV',
  OFFICIANTE_MATR = 'OFFICIANTE_MATR',
  OFFICIANTE_CITT = 'OFFICIANTE_CITT',
  OFFICIANTE_TRAS = 'OFFICIANTE_TRAS',
  UNICIV1 = 'UNICIV1',
  UNICIV2 = 'UNICIV2',
  UNICIV1_SCIO = 'UNICIV1_SCIO',
  UNICIV2_SCIO = 'UNICIV2_SCIO',
  TESTIMONE3 = 'TESTIMONE3',
  TESTIMONE4 = 'TESTIMONE4',
  SEGRCOM_UNI_CIV = 'SEGRCOM_UNI_CIV',
  SEGRCOM_MATR = 'SEGRCOM_MATR',
  PADRESPOSO = 'PADRESPOSO',
  MADRESPOSO = 'MADRESPOSO',
  TUTORESPOSO = 'TUTORESPOSO',
  CURATORESPOSO = 'CURATORESPOSO',
  PADRESPOSA = 'PADRESPOSA',
  MADRESPOSA = 'MADRESPOSA',
  TUTORESPOSA = 'TUTORESPOSA',
  CURATORESPOSA = 'CURATORESPOSA',
  SPOSO = 'SPOSO',
  SPOSA = 'SPOSA',
  AVVOC1 = 'AVVOC1',
  AVVOC2 = 'AVVOC2',
  AVVOC3 = 'AVVOC3',
  AVVOC4 = 'AVVOC4',
  AVVOC5 = 'AVVOC5',
  AVVOCUC1 = 'AVVOCUC1',
  AVVOCUC2 = 'AVVOCUC2',
  FIGLIO = 'FIGLIO',
}

export enum CodeSection {
  CONSENSO_PADRE = 'ATTO_NOTARILE_CONSENSO_PADRE',
  CONSENSO_MADRE = 'ATTO_NOTARILE_CONSENSO_MADRE',
  DATI_DECESSO = 'DATI_DECESSO',
  DATI_SPECIFICI_CITTADINANZA = 'DATI_SPECIFICI_CITTADINANZA',
  DATI_EVENTO_CITTADINANZA = 'DATI_EVENTO_CITTADINANZA',
  TIPO_MANCATO_CONS_MADRE = 'TIPO_MANCATO_CONS_MADRE',
  AUTORIZZAZIONE_RICONOSCIMENTO_PADRE = 'AUTORIZZAZIONE_RICONOSCIMENTO_PADRE',
  DATI_SENTENZA_RICONOSCIMENTO = 'DATI_SENTENZA_RICONOSCIMENTO',
  DATI_ATTO_TRASCRIZIONE = 'DATI_ATTO_TRASCRIZIONE',
  DATI_AUTORITA_MITTENTE = 'DATI_AUTORITA_MITTENTE',
  DATI_PROVCOM = 'DATI_PROVCOM',
  DECRETO_INTIMAZIONE = 'DECRETO_INTIMAZIONE',
  TRASCRIZIONE_NASCITA = 'TRASCRIZIONE_NASCITA',
  DATI_TRASCRIZIONE = 'DATI_TRASCRIZIONE',
  DATI_TRASCRIZIONE_TP_RICHIEDENTE_FG = 'DATI_TRASCRIZIONE_TP_RICHIEDENTE_FG',
  DATI_TRASCRIZIONE_TP_RICHIEDENTE = 'DATI_TRASCRIZIONE_TP_RICHIEDENTE',
  DATI_TRASCRIZIONE_RICHIEDENTE = 'DATI_TRASCRIZIONE_RICHIEDENTE',
  DATI_TRASCRIZIONE_MORTE = 'DATI_TRASCRIZIONE_MORTE',
  DATI_TRASCRIZIONE_CITTADINANZA = 'DATI_TRASCRIZIONE_CITTADINANZA',
  TRASCRIZIONE_CITTADINANZA = 'TRASCRIZIONE_CITTADINANZA',
  DATI_TRASCRIZIONE_UNIONE_CIVILE = 'DATI_TRASCRIZIONE_UNIONE_CIVILE',
  DATI_TRASCRIZIONE_MATRIMONIO = 'DATI_TRASCRIZIONE_MATRIMONIO',
  DATI_TRASCRIZIONE_AUTORITA_MITTENTE = 'DATI_TRASCRIZIONE_AUTORITA_MITTENTE',
  DATI_TRASCRIZIONE_NEGOZ = 'DATI_TRASCRIZIONE_NEGOZ',
  DATI_TRASCRIZIONE_SEPARAZIONE = 'DATI_TRASCRIZIONE_SEPARAZIONE',
  DATI_UNIONE_CIVILE = 'DATI_UNIONE_CIVILE',
  DATI_MATRIMONIO = 'DATI_MATRIMONIO',
  GENIT_CHE_TRASMETTE_CIT = 'GENIT_CHE_TRASMETTE_CIT',
  RIC_GENITORE_ITALIANO = 'RIC_GENITORE_ITALIANO',
  ESI_ACC_PROVV_SIND = 'ESI_ACC_PROVV_SIND',
  ESI_ACC_PROVV_SIND2 = 'ESI_ACC_PROVV_SIND2',
  PUBBLICO_IMPIEGO = 'PUBBLICO_IMPIEGO',
  SENTENZA_ADOZIONE = 'SENTENZA_ADOZIONE',
  SENTENZA_REVOCA_ADOZIONE = 'SENTENZA_REVOCA_ADOZIONE',
  DATI_SERVIZIO_MILITARE = 'DATI_SERVIZIO_MILITARE',
  ATTO_COLLEGATO = 'ATTO_COLLEGATO',
  ATTO_COLLEGATO_CITTADINANZA = 'ATTO_COLLEGATO_CITTADINANZA',
  CITTADINANZA_ATTO_NASCITA = 'CITTADINANZA_ATTO_NASCITA',
  ATTO_NASCITA_FIGLIO = 'ATTO_NASCITA_FIGLIO',
  ATTO_NASCITA_CONIUGE = 'ATTO_NASCITA_CONIUGE',
  ATTO_NASCITA_UNITO = 'ATTO_NASCITA_UNITO',
  ATTO_RICONOSCIMENTO = 'ATTO_RICONOSCIMENTO',
  ATTO_RICONOSCIMENTO_MADRE = 'ATTO_RICONOSCIMENTO_MADRE',
  ATTO_RICONOSCIMENTO_PADRE = 'ATTO_RICONOSCIMENTO_PADRE',
  ATTO_MATRIMONIO = 'ATTO_MATRIMONIO',
  ATTO_UNIONE_CIVILE = 'ATTO_UNIONE_CIVILE',
  ATTO_ASSENSO_FIGLIO = 'ATTO_ASSENSO_FIGLIO',
  ATTO_ASSENSO_FIGLIO_RESO = 'ATTO_ASSENSO_FIGLIO_RESO',
  ASSENSO_FIGLIO = 'ASSENSO_FIGLIO',
  COMPOSIZIONE_LIBERA_ATTO = 'COMPOSIZIONE_LIBERA_ATTO',
  COMPOSIZIONE_LIBERA_ATTO_DUE = 'COMPOSIZIONE_LIBERA_ATTO_DUE',
  ANNOTAZIONE_RETTIFICATIVA = 'ANNOTAZIONE_RETTIFICATIVA',
  DG_ANNOTAZIONE_MODIFICATIVA = 'DG_ANNOTAZIONE_MODIFICATIVA',
  ANNOTAZIONE_MODIFICATIVA = 'ANNOTAZIONE_MODIFICATIVA',
  DATI_GENERALI = 'DATI_GENERALI',
  DATI_GEN = 'DATI_GEN',
  DATI_GENERALI_RICONOSCIMENTO = 'DATI_GENERALI_RICONOSCIMENTO',
  DATI_GENERALI_CONS_ASS_RICO = 'DATI_GENERALI_CONS_ASS_RICO',
  DATI_GENERALI_ASS_RICO = 'DATI_GENERALI_ASS_RICO',
  DATI_GENERALI_ASS_RICO_P = 'DATI_GENERALI_ASS_RICO_P',
  DATI_GENERALI_CONSENSO = 'DATI_GENERALI_CONSENSO',
  DATI_GENERALI_PRES_DOC = 'DATI_GENERALI_PRES_DOC',
  DATI_GENERALI_PRES_DOC_EVENTO = 'DATI_GENERALI_PRES_DOC_EVENTO',
  DATI_GENERALI_CONS_RICO = 'DATI_GENERALI_CONS_RICO',
  DATI_GENERALI_CONS_RICO_EVENTO = 'DATI_GENERALI_CONS_RICO_EVENTO',
  DATI_GENERALI_CONS_ASS_COGNRID_RICO = 'DATI_GENERALI_CONS_ASS_COGNRID_RICO',
  DATI_GENERALI_CONS_RICO_SENT = 'DATI_GENERALI_CONS_RICO_SENT',
  DATI_GENERALI_RICO_GEN = 'DATI_GENERALI_RICO_GEN',
  DATI_GENERALI_NEGOZ = 'DATI_GENERALI_NEGOZ',
  DATI_RICONCILIAZIONE = 'DATI_RICONCILIAZIONE',
  DATI_SEPARUC = 'DATI_SEPARUC',
  DATI_REGISTRO_EMERGENZA = 'DATI_REGISTRO_EMERGENZA',
  ATTO_DI_CONSENSO_ATCO = 'ATTO_DI_CONSENSO_ATCO',
  ATTO_DI_CONSENSO_ATCOP = 'ATTO_DI_CONSENSO_ATCOP',
  ATTO_DI_CONSENSO_ED = 'ATTO_DI_CONSENSO_ED',
  CONSENSO_SENTENZA = 'CONSENSO_SENTENZA',
  SENTENZA_CONSENSO = 'SENTENZA_CONSENSO',
  CONSENSO_ALTRO = 'CONSENSO_ALTRO',
  CONSENSO_ATTO = 'CONSENSO_ATTO',
  DATI_PROVVEDIMENTO_SINDACO = 'DATI_PROVVEDIMENTO_SINDACO',
  ESTREMI_SENTENZA_MADRE = 'ESTREMI_SENTENZA_MADRE',
  ESTREMI_SENTENZA_PADRE = 'ESTREMI_SENTENZA_PADRE',
  ATTO_CONSENSO_ATCOP = 'ATTO_CONSENSO_ATCOP',
  ATTO_CONSENSO_ATCOM = 'ATTO_CONSENSO_ATCOM',
  DATI_ACCERTAMENTO = 'DATI_ACCERTAMENTO',
  DATI_ACCERTAMENTO_BIS = 'DATI_ACCERTAMENTO_BIS',
  ATTO_NOTARILE_CONSENSO_PADRE = 'ATTO_NOTARILE_CONSENSO_PADRE',
  ATTO_NOTARILE_CONSENSO_MADRE = 'ATTO_NOTARILE_CONSENSO_MADRE',
  SENTENZA_MORTE_PRESUNTA = 'SENTENZA_MORTE_PRESUNTA',
  SENTENZA_ACCERTAMENTO_MORTE_PRESUNTA = 'SENTENZA_ACCERTAMENTO_MORTE_PRESUNTA',
  MORTE_ATTO_NASCITA_DECEDUTO = 'MORTE_ATTO_NASCITA_DECEDUTO',
  UNIONE_CIVILE_ATTO_NASCITA_CONIUGE1 = 'UNIONE_CIVILE_ATTO_NASCITA_CONIUGE1',
  UNIONE_CIVILE_ATTO_NASCITA_CONIUGE2 = 'UNIONE_CIVILE_ATTO_NASCITA_CONIUGE2',
  ULTIMO_LUOGO = 'ULTIMO_LUOGO',
  SENTENZA_PATERNITA = 'SENTENZA_PATERNITA',
  ATTO_COLLEGATO_GEN = 'ATTO_COLLEGATO_GEN',
  ATTO_TRASCRITTO_C = 'ATTO_TRASCRITTO_C',
  ATTO_DA_RETTIFICARE = 'ATTO_DA_RETTIFICARE',
  ATTO_ANNOTAZIONE_MODIFICATIVA = 'ATTO_ANNOTAZIONE_MODIFICATIVA',
  ANNOTAZIONE_CONTESTUALE = 'ANNOTAZIONE_CONTESTUALE',
  DATI_SPECIFICI_UNICIV = 'DATI_SPECIFICI_UNICIV',
  CERT_RIC_UNICIV_1 = 'CERT_RIC_UNICIV_1',
  CERT_RIC_UNICIV_2 = 'CERT_RIC_UNICIV_2',
  REGIME_PATRIMONIALE = 'REGIME_PATRIMONIALE',
  CERT_IMPEDIMENTO_GENERICO = 'CERT_IMPEDIMENTO_GENERICO',
  DATI_SPECIFICI_MATR = 'DATI_SPECIFICI_MATR',
  SCIOGLIMENTO_UNIONE_CIVILE_COMUNICAZIONE = 'SCIOGLIMENTO_UNIONE_CIVILE_COMUNICAZIONE',
  SCIOGLIMENTO_ATTO_UNIONE_CIVILE = 'SCIOGLIMENTO_ATTO_UNIONE_CIVILE',
  MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSO = 'MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSO',
  MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSA = 'MATRIMONIO_NOMINA_ASSISTENTE_LEGALE_SPOSA',
  MATRIMONIO_SENTENZA_OMISSIONE_PUBBLICAZIONE = 'MATRIMONIO_SENTENZA_OMISSIONE_PUBBLICAZIONE',
  MATRIMONIO_ESTINZIONE_RIGETTO_OPPOSIZIONE = 'MATRIMONIO_ESTINZIONE_RIGETTO_OPPOSIZIONE',
  MATRIMONIO_AUTORIZZAZIONE_DIFETTO_ETA = 'MATRIMONIO_AUTORIZZAZIONE_DIFETTO_ETA',
  MATRIMONIO_AUTORIZZAZIONE_PARENTELA = 'MATRIMONIO_AUTORIZZAZIONE_PARENTELA',
  MATRIMONIO_AUTORIZZAZIONE_DIVIETO_TEMP = 'MATRIMONIO_AUTORIZZAZIONE_DIVIETO_TEMP',
  MATRIMONIO_ATTO_NASCITA_SPOSO = 'MATRIMONIO_ATTO_NASCITA_SPOSO',
  MATRIMONIO_ATTO_NASCITA_SPOSA = 'MATRIMONIO_ATTO_NASCITA_SPOSA',
  MATRIMONIO_ATTO_NASCITA_FIGLIO = 'MATRIMONIO_ATTO_NASCITA_FIGLIO',
  MATRIMONIO_ATTO = 'MATRIMONIO_ATTO',
  CERT_IMPEDIMENTO_SPOSO = 'CERT_IMPEDIMENTO_SPOSO',
  CERT_IMPEDIMENTO_SPOSA = 'CERT_IMPEDIMENTO_SPOSA',
  PROVVEDIMENTO_ESTINZIONE_OPPOSIZIONE = 'PROVVEDIMENTO_ESTINZIONE_OPPOSIZIONE',
  PROVVEDIMENTO_RIGETTO_OPPOSIZIONE = 'PROVVEDIMENTO_RIGETTO_OPPOSIZIONE',
  PROVVEDIMENTO_MIN_INTER = 'PROVVEDIMENTO_MIN_INTER',
  PUBBLICAZIONE_1 = 'PUBBLICAZIONE_1',
  PUBBLICAZIONE_2 = 'PUBBLICAZIONE_2',
  DATI_SEPAR = 'DATI_SEPAR',
  PROVVEDIMENTO_SEPARAZIONE = 'PROVVEDIMENTO_SEPARAZIONE',
  ACCORDO_SEPARAZIONE = 'ACCORDO_SEPARAZIONE',
  CONFERMA_ACCORDO_SEP = 'CONFERMA_ACCORDO_SEP',
  SEPARAZIONE_ATTO_ACCORDO = 'SEPARAZIONE_ATTO_ACCORDO',
  DATI_PROVVEDIMENTO = 'DATI_PROVVEDIMENTO',
  DATI_INTEGRAZIONE = 'DATI_INTEGRAZIONE',
  DATI_SENTENZA_ECCLESIASTICA = 'DATI_SENTENZA_ECCLESIASTICA',
  SCIOGLIMENTO_ATTO_ACCORDO = 'SCIOGLIMENTO_ATTO_ACCORDO',
  RIC_ATTO = 'RIC_ATTO',
  NEGOZIAZIONE_ASSISTITA = 'NEGOZIAZIONE_ASSISTITA',
  TESTO_DELEGA_UNIONE_CIVILE = 'TESTO_DELEGA_UNIONE_CIVILE',
  TESTO_DELEGA_MATRIMONIO = 'TESTO_DELEGA_MATRIMONIO',
  ENTE_DICHIARANTE = 'ENTE_DICHIARANTE',
  LEGGE_CITTADINANZA = 'LEGGE_CITTADINANZA',
}
